import React from 'react';
import ReactDOM from 'react-dom';

import BufferTabView from 'buffers/BufferTabView';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

import ProcessTaskDetailsOutputs from './ProcessTaskDetailsOutputs';
import ProcessTaskDetailsOutputsTabState from './ProcessTaskDetailsOutputsTabState';

export default class ProcessTaskDetailsOutputsTabView extends BufferTabView<ProcessTaskDetailsOutputsTabState> {
  render(): this {
    const props = {
      processTaskId: this.model.get('processTaskId'),
    };
    renderToDOM(
      <div className="react-tab-container">
        <ProcessTaskDetailsOutputs processTaskId={props.processTaskId} />
      </div>,
      this.el
    );
    return this;
  }

  remove(): Backbone.View<ProcessTaskDetailsOutputsTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

ProcessTaskDetailsOutputsTabView.prototype.className = 'buffer-tab buffer-tab--no-padding';
